(function () {
  var storageKey = 'hexcaps-recently-viewed';
  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var currentData = section.querySelector('[data-current-product]');
  var grid = section.querySelector('[data-recently-viewed-grid]');
  if (!currentData || !grid) return;

  try {
    var current = JSON.parse(currentData.textContent);
    var stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    var previous = stored.filter(function (item) {
      return item && item.handle && item.handle !== current.handle;
    }).slice(0, 4);

    if (previous.length) {
      grid.innerHTML = previous.map(function (item) {
        var availability = item.available ? 'View product' : 'Sold out';
        return [
          '<article class="recently-viewed__card">',
          '<a href="', item.url, '" class="recently-viewed__image">',
          item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="500" height="500">' : '',
          '</a>',
          '<div>',
          '<h3><a href="', item.url, '">', item.title, '</a></h3>',
          '<p>', item.price, '</p>',
          '<a class="button button--secondary" href="', item.url, '">', availability, '</a>',
          '</div>',
          '</article>'
        ].join('');
      }).join('');
      section.hidden = false;
    }

    localStorage.setItem(storageKey, JSON.stringify(
      [current].concat(stored.filter(function (item) {
        return item && item.handle !== current.handle;
      })).slice(0, 8)
    ));
  } catch (error) {
    section.hidden = true;
  }
})();
